/**
 * Définitions des métriques de rétention pour les tooltips explicatifs
 */

const RETENTION_METRICS_DEFINITIONS = {
  onboardedBranches: {
    title: "Branches onboardées",
    description: "Nombre total de branches ayant fait au moins 1 commande",
    formula: "COUNT(branches avec ≥ 1 commande)",
  },
  recurringBranches: {
    title: "Branches récurrentes",
    description: "Branches actives ayant fait plusieurs commandes (exclut les branches churnées)",
    formula: "COUNT(branches avec > 1 commande ET non-churnées)",
  },
  churnedBranches: {
    title: "Branches churnées",
    description: "Branches inactives depuis trop longtemps (basé sur leur cycle d'achat naturel)",
    formula: "COUNT(branches sans commande depuis > 2× cycle normal)",
  },
  retentionRatio: {
    title: "Taux de rétention",
    description: "Pourcentage de branches qui ne sont pas churnées",
    formula: "100% - Taux de churn",
  },
  churnRate: {
    title: "Taux de churn",
    description: "Pourcentage de branches onboardées qui ont churné",
    formula: "Branches churnées / Branches onboardées × 100",
  },
  totalRecurringOrders: {
    title: "Commandes récurrentes",
    description: "Total des commandes effectuées par les branches actives (exclut les premières commandes)",
    formula: "SUM(commandes - 1) pour branches actives",
  },
  avgRecurringOrdersPerBranch: {
    title: "Commandes moy. par branche",
    description: "Nombre moyen de commandes récurrentes par branche active récurrente",
    formula: "Commandes récurrentes / Branches récurrentes",
  },
  avgSalesRecurringOrders: {
    title: "Ventes moy. commandes récur.",
    description: "Montant moyen des ventes pour les commandes récurrentes",
    formula: "AVG(montant commandes récurrentes)",
  },
  normalCycleDays: {
    title: "Cycle d'achat normal",
    description: "Délai médian entre deux commandes (calculé automatiquement)",
    formula: "MEDIAN(jours entre commandes consécutives)",
  },
  gracePeriodDays: {
    title: "Période de grâce",
    description: "Délai avant de considérer une branche comme churnée",
    formula: "MAX(60 jours, MIN(365 jours, 2× cycle normal))",
  },
}

export default RETENTION_METRICS_DEFINITIONS 